import {createAsyncThunk} from '@reduxjs/toolkit';
import type {LanguageData} from '@Components/language-selector/language-selector.types';

export const getPMWLangsVersion = createAsyncThunk<{version: number}>('getPMWLangsVersion', async () => {
  return window.PMW.readLocal('lang/getPMWLangsVersion');
});
export const getSupportedLanguages = createAsyncThunk<{pmwLangs: LanguageData[], version: number}>('getSupportedLanguages', async () => {
  return window.PMW.readLocal('lang/getSupportedLanguages');
});
